import { jsPDF } from "jspdf";
import html2canvas from "html2canvas";

export async function exportTableToPDF(
    tableElement: HTMLElement,
    filename = "table.pdf"
) {
  const aFormats: Record<string, [number, number]> = {
    a0: [841, 1189],
    a1: [594, 841],
    a2: [420, 594],
    a3: [297, 420],
    a4: [210, 297],
    a5: [148, 210],
    a6: [105, 148],
    a7: [74, 105],
    a8: [52, 74],
    a9: [37, 52],
    a10: [26, 37],
  };

  const basePxToMm = 0.264583;
  const scale = 2;

  const rect = tableElement.getBoundingClientRect();
  const tableWidthMm = (rect.width * basePxToMm) / scale;
  const tableHeightMm = (rect.height * basePxToMm) / scale;

  let chosenFormat: keyof typeof aFormats = "a4";
  let orientation: "p" | "l" = "p";

  for (const [format, [w, h]] of Object.entries(aFormats)) {
    if (tableWidthMm <= w && tableHeightMm <= h) {
      chosenFormat = format as keyof typeof aFormats;
      orientation = "p";
      break;
    }
    if (tableWidthMm <= h && tableHeightMm <= w) {
      chosenFormat = format as keyof typeof aFormats;
      orientation = "l";
      break;
    }
  }

  const pdf = new jsPDF({
    unit: "mm",
    format: chosenFormat,
    orientation,
  });

  const canvas = await html2canvas(tableElement, {
    scale,
    useCORS: true,
    backgroundColor: "#ffffff",
  });

  const imgData = canvas.toDataURL("image/jpeg");

  const margin = 20;
  const imgWidth = pdf.internal.pageSize.getWidth() - margin * 2;
  const imgHeight = (canvas.height * imgWidth) / canvas.width;

  pdf.addImage(imgData, "JPEG", margin, margin, imgWidth, imgHeight);
  pdf.save(filename);
}